import React, { useState } from "react";
import API from "../services/api";

function UploadEpaper() {
  const [title, setTitle] = useState("");
  const [edition, setEdition] = useState("");
  const [date, setDate] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("edition", edition);
    formData.append("publish_date", date);
    formData.append("pdf", file);

    try {
      await API.post("/epapers/upload", formData);
      alert("Epaper uploaded successfully!");
      setTitle("");
      setEdition("");
      setDate("");
      setFile(null);
    } catch (error) {
      console.log(error);
      alert("Failed to upload Epaper.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-200 mt-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-3">Upload New Edition</h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Paper Title</label>
          <input
            type="text"
            required
            value={title}
            placeholder="e.g. Pratyaksha News - Main Edition"
            className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-news-blue focus:border-news-blue outline-none transition"
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Edition Area</label>
            <select
              required
              value={edition}
              className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-news-blue focus:border-news-blue outline-none transition bg-white"
              onChange={(e) => setEdition(e.target.value)}
            >
              <option value="" disabled>Select Edition Type</option>
              <option value="Main Edition">Main Edition</option>
              <option value="District Edition">District Edition</option>
              <option value="Sunday Magazines">Sunday Magazines</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Publish Date</label>
            <input
              type="date"
              required
              value={date}
              className="w-full border border-gray-300 rounded px-4 py-2 focus:ring-2 focus:ring-news-blue focus:border-news-blue outline-none transition"
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">PDF File</label>
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition cursor-pointer relative">
            <input
              type="file"
              required
              accept="application/pdf"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              onChange={(e) => setFile(e.target.files[0])}
            />
            <div className="text-gray-500">
               {file ? (
                 <span className="text-green-600 font-semibold">{file.name}</span>
               ) : (
                 <span>Drag and drop PDF here or <span className="text-news-blue">browse</span></span>
               )}
            </div>
          </div>
        </div>

        <button
          disabled={loading}
          className={`w-full text-white font-bold py-3 rounded uppercase tracking-wide transition ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-news-blue hover:bg-blue-800'}`}
        >
          {loading ? 'Uploading...' : 'Publish Edition'}
        </button>
      </form>
    </div>
  );
}

export default UploadEpaper;